import AuthReducer from "./authReducer";
import {combineReducers} from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import PolicyReducer from "./policyReducer";
const rootReducer = combineReducers({
    Auth: AuthReducer,
    Policy: PolicyReducer,
})
const rootPersistConfig = {
    key: 'root',
    storage,
    whitelist: ['Auth','Policy'],
    // blacklist: [''],
    stateReconciler: autoMergeLevel2,
}
export default persistReducer(rootPersistConfig, rootReducer);